<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 14:34:38
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-30 11:20:35
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/Img-to-Img-Setting.vue
-->
<template>
    <div
        class="flex flex-col justify-between bg-setting-bg max-h-[inherit] w-full overflow-y-auto rounded-lg p-4 lg:p-6 lg:pb-0 lg:!w-[424px] lg:border-r lg:border-r-[#1D1D20]"
    >
        <!-- 设置最小高度减少 CLS 布局偏移 -->
        <div>
            <div class="flex items-center gap-2 justify-end lg:justify-between lg:mb-[30px]">
                <span
                    class="hidden lg:block text-white cursor-default text-base font-semibold md:text-lg"
                >
                    {{ t('menus.imageToImage') }}
                </span>
                <!-- <tool-batch-switch
                    v-model="batch_generate"
                    :label="t('batchTools.batchGenerate')"
                ></tool-batch-switch> -->
                <tool-single-img-edit
                    v-model:generate_type="generate_type"
                ></tool-single-img-edit>
            </div>
            <tool-model-select
                v-if="!batch_generate"
                v-model:model="edit_model"
                :model_list="
                    generate_type === 'single' ? multiModelList : modelList
                "
                :type="props.type"
            ></tool-model-select>
            <tool-model-select-mult
                v-else
                v-model:models="edit_model_list"
                :model_list="multiModelList"
                :type="props.type"
            ></tool-model-select-mult>
            <tool-image-upload-mult
                :show_tips="true"
                :label="t('menus.control_composition')"
                v-model:image_list="edit_image_list"
                v-model:model="edit_model"
                v-model:upload_image_limit="upload_image_limit"
            ></tool-image-upload-mult>
            <tool-prompt-textarea
                v-model:prompt="edit_prompt"
                :recommend_list="recommend_list"
                v-model:prompt_length_limit="prompt_length_limit"
            ></tool-prompt-textarea>
            <!-- <tool-create-style v-model:style="edit_style"></tool-create-style> -->
            <tool-aspect-radio
                :show_tips="true"
                :label="t('menus.any_aspect_ratio')"
                v-model:aspect_ratio="edit_aspect_ratio"
                :aspect_ratio_list="aspectRatioList"
            ></tool-aspect-radio>
            <!-- 使用 v-show 替代 v-if 减少 CLS 布局偏移 -->
            <tool-video-size
                :show_tips="true"
                :label="t('menus.high_res_output')"
                :tip_content="t('seo.imageToImage.page.output')"
                v-show="resolutionList?.length"
                type="IMAGE"
                v-model:video_size="image_size"
                :video_size_list="resolutionList || []"
            ></tool-video-size>
            <tool-image-number
                v-model:output_image_number="edit_output_image_number"
                :num_images="num_images"
                :batch_generate="batch_generate"
            ></tool-image-number>
            <tool-online-search-switch
                v-show="has_web_search"
                v-model:use_web_search="use_web_search"
            ></tool-online-search-switch>
            <tool-public-visibility
                v-model:public_visible="public_visible"
            ></tool-public-visibility>
            <tool-copyright-protection
                v-model:copyright_protection="copyright_protection"
            ></tool-copyright-protection>
        </div>
        <tool-credit-required
            class="sticky bottom-0 py-4 !mb-0 bg-setting-bg"
            :type="props.type"
            :create_btn_disable="can_generate"
            workflowType="imgEditBatch"
            :m="cost_model"
            :p="edit_aspect_ratio"
            :n="generate_type === 'single' ? img_num : edit_output_image_number"
            :r1="image_size"
            :loading="props.create_loading"
        ></tool-credit-required>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from '~/composables/useI18n'
import type { SettingType } from '~/types'
import { ModelType } from '~/types'
import { useAppStore } from '~/stores/app'
import { aspectRatioEnums, noticeMessagePopup } from '~/utils/common'
const appStore = useAppStore()
const modelData = computed(() => appStore.modelData)

const { t } = useI18n()
// 模型对比（batch_generate=true）时需要过滤的模型
const MODEL_COMPARE_EXCLUDE_LIST = [
    'DREAMINA_3',
    'DREAMINA_4',
    'MIDJOURNEY',
    'WERYAI_IMAGE_1_0',
]
const props = withDefaults(
    defineProps<{
        type: any
        create_btn_disable: boolean
        create_loading: boolean
        recommend_list: Array<any>
    }>(),
    {
        type: 'image_to_image',
        create_btn_disable: false,
        create_loading: false,
        recommend_list: () => [],
    }
)

const model_tool_type = 'imgEditModels'

const edit_model = defineModel('edit_model', {
    type: String,
    default: '',
})

const edit_image_list = defineModel('edit_image_list', {
    type: Array<string>,
    default: () => [],
})

const edit_prompt = defineModel('edit_prompt', {
    type: String,
    default: '',
})

const edit_style = defineModel('edit_style', {
    type: String,
    default: 'auto',
})

const edit_aspect_ratio = defineModel('edit_aspect_ratio', {
    type: String,
    default: '',
})

const edit_output_image_number = defineModel('edit_output_image_number', {
    type: Number,
    default: 1,
})

const batch_generate = defineModel('batch_generate', {
    type: Boolean,
    default: false,
})

const public_visible = defineModel('public_visible', {
    type: Boolean,
    default: true,
})
const copyright_protection = defineModel('copyright_protection', {
    type: Boolean,
    default: true,
})

const use_web_search = defineModel('use_web_search', {
    type: Boolean,
    default: false,
})

const generate_type = defineModel('generate_type', {
    type: String,
    default: 'standard',
})

const has_web_search = computed(() => {
    return (
        edit_model.value === 'CHATBOT_GEMINI_3_PRO_IMAGE_PREVIEW' &&
        !batch_generate.value
    )
})

const edit_model_list = defineModel('edit_model_list', {
    type: Array<string>,
    default: () => [],
})

const aspectRatioList = ref<Array<any>>([])
const batch_num_images = [1, 2, 3, 4]
const num_images = ref<Array<any>>(batch_num_images)
const upload_image_limit = ref<number>(10)
const resolutionList = ref<Array<any> | null>(null)
const image_size = defineModel('image_size', {
    type: String,
    default: '',
})
const prompt_length_limit = ref<number>(5000)
const img_num: any = computed(() => {
    return (
        (edit_image_list.value?.length || 1) * edit_output_image_number.value
    )?.toFixed(0)
})
const cost_model = computed(() => {
    return batch_generate.value
        ? edit_model_list.value?.join(',')
        : edit_model.value
})

const modelList = computed(() => {
    if (!modelData.value) return []
    const arr = modelData.value?.image_models?.[props.type] || {}

    // 只有当 edit_model.value 完全为空且没有设置任何值时，才设置默认值
    // 如果已经通过路由参数或其他方式设置了值，就不再覆盖
    if (!edit_model.value && arr.length > 0) {
        // 注释掉默认选择逻辑，让父组件控制默认值
        // edit_model.value = arr[0]?.model_key || ''
    }

    // 仅在非模型对比模式下，为普通/单图模式提供一个默认多选列表（避免进入模型对比时被这里“抢写”覆盖）
    if (!batch_generate.value && !edit_model_list.value?.length) {
        edit_model_list.value = [arr[0]?.model_key || '']
    }
    return arr
})

const multiModelList = computed(() => {
    // 模型对比（batch_generate）或 single 模式下过滤；其他模式不做过滤
    if (!batch_generate.value && generate_type.value !== 'single') {
        return modelList.value
    }
    return modelList.value?.filter(
        (it: any) => !MODEL_COMPARE_EXCLUDE_LIST.includes(it.model_key)
    )
})

const isAllowedInModelCompare = (modelKey?: string) => {
    if (!modelKey) return false
    return !MODEL_COMPARE_EXCLUDE_LIST.includes(modelKey)
}

const uniqKeepOrder = (arr: string[]) => {
    const res: string[] = []
    for (const it of arr) {
        if (!it) continue
        if (res.includes(it)) continue
        res.push(it)
    }
    return res
}

const getFirstAllowedCompareModel = () => {
    // 优先用已过滤的列表作为兜底（保证可选）
    const first = multiModelList.value?.[0]?.model_key
    if (first) return first
    // 再兜底：从全量列表里找一个不在排除名单的
    const fromAll = modelList.value?.find((it: any) =>
        isAllowedInModelCompare(it?.model_key)
    )?.model_key
    return fromAll || ''
}

// 标准模式 -> 模型对比：先清空对比已选，再把当前标准模型带入多选，并过滤掉排除模型
const syncStandardToCompare = () => {
    const standardModel = edit_model.value
    const next = uniqKeepOrder([standardModel].filter(isAllowedInModelCompare))

    // 如果过滤后为空，则用兜底模型
    if (!next.length) {
        const fallback = getFirstAllowedCompareModel()
        if (fallback) next.push(fallback)
    }

    if (JSON.stringify(edit_model_list.value || []) !== JSON.stringify(next)) {
        edit_model_list.value = next
    }
    if (next[0] && edit_model.value !== next[0]) {
        edit_model.value = next[0]
    }
}

// 模型对比 -> 标准模式：保留一个模型回填给标准模型
const syncCompareToStandard = () => {
    const list = Array.isArray(edit_model_list.value)
        ? edit_model_list.value
        : []
    const first = list.find(Boolean) || ''
    if (first && edit_model.value !== first) {
        edit_model.value = first
    }
}

// 根据模型和尺寸更新比例列表的函数
const updateAspectRatioList = () => {
    if (!edit_model.value || !modelData.value) return

    let same_ = modelData.value?.image_models?.[props.type]?.find(
        (it: any) => it.model_key === edit_model.value
    )

    if (!same_) return

    // 如果模型是 DREAMINA_4 且尺寸是 1k，则只显示 1:1 比例
    if (
        ['DREAMINA_4'].includes(edit_model.value) &&
        image_size.value === '1k'
    ) {
        aspectRatioList.value = ['1:1']
        edit_aspect_ratio.value = '1:1'
    } else {
        // 其他情况使用原始的比例列表
        aspectRatioList.value = same_?.image_sizes || []
        // 如果父组件已经通过本地缓存恢复了宽高比，则不要用默认值覆盖
        if (!edit_aspect_ratio.value) {
            edit_aspect_ratio.value = aspectRatioList.value?.[0] || ''
        } else {
            let same_aspect_ratio = aspectRatioList.value?.find(
                (it: string) => it === edit_aspect_ratio.value
            )
            if (!same_aspect_ratio) {
                edit_aspect_ratio.value = aspectRatioList.value?.[0] || ''
            }
        }
    }
}

watch(
    [() => edit_model.value, () => modelData.value, () => generate_type.value],
    ([newVal, newVal2, newVal3]: [string, any, string]) => {
        if (newVal && newVal2) {
            let same_ = newVal2?.image_models?.[props.type]?.find(
                (it: any) => it.model_key === newVal
            )
            upload_image_limit.value = same_?.upload_image_limit || 10
            resolutionList.value = same_?.resolutions
            image_size.value = resolutionList.value?.[0] || ''
            num_images.value =
                newVal3 === 'batch' ? batch_num_images : same_?.num_images

            edit_output_image_number.value = num_images.value?.[0] || 1
            prompt_length_limit.value = same_?.prompt_length_limit || 5000
            if (edit_image_list.value.length > upload_image_limit.value) {
                noticeMessagePopup(
                    t('tools.maxUploadCount', {
                        count: upload_image_limit.value,
                    }),
                    t('common.tip'),
                    'warning',
                    5000,
                    ''
                )
            }

            // 调用更新比例列表的函数
            updateAspectRatioList()
        }
    },
    {
        immediate: true,
        flush: 'post',
    }
)

// single 模式下如果当前模型被过滤（或为空），自动切换到可用模型，避免“选中项不在列表里”
watch(
    () => [generate_type.value, batch_generate.value, modelList.value],
    ([gt, bg]) => {
        // 仅处理 single 且非模型对比
        if (bg) return
        if (gt !== 'single') return

        if (!edit_model.value || !isAllowedInModelCompare(edit_model.value)) {
            const fallback = getFirstAllowedCompareModel()
            if (fallback) edit_model.value = fallback
        }
    },
    { immediate: true }
)

// 监听 image_size 变化，当尺寸变化时也需要重新判断比例
watch(
    () => image_size.value,
    () => {
        updateAspectRatioList()
    }
)

// 模型对比模式下：保证 edit_model 始终等于多选的第一项（用于分辨率/张数等联动）
watch(
    () => edit_model_list.value,
    newList => {
        if (!batch_generate.value) return
        if (!Array.isArray(newList)) return

        const normalized = uniqKeepOrder(
            newList.filter(isAllowedInModelCompare)
        )
        const fallback = getFirstAllowedCompareModel()
        // 对比模式不允许空：用户清空时自动补回一个可用模型
        const ensured = normalized.length
            ? normalized
            : fallback
              ? [fallback]
              : []

        if (JSON.stringify(newList) !== JSON.stringify(ensured)) {
            edit_model_list.value = ensured
        }

        const first = ensured[0] || ''
        if (first && edit_model.value !== first) {
            edit_model.value = first
        }
    },
    { deep: true }
)

const batch_generate_aspect_ratio_list = [
    '9:16',
    '1:1',
    '16:9',
    '3:2',
    '2:3',
    '3:4',
    '4:3',
]

const can_generate = computed(() => {
    const has_loading_image = edit_image_list.value.some(
        (it: any) => it.loading
    )
    return (
        props.create_btn_disable ||
        edit_image_list.value.length > upload_image_limit.value ||
        has_loading_image
    )
})
watch(
    () => batch_generate.value,
    newVal => {
        if (newVal) {
            // 进入模型对比：先清空对比已选，再同步标准模式选择（并过滤排除模型）
            edit_model_list.value = []
            syncStandardToCompare()
            // 如果父组件已经从本地缓存恢复了数量，则保留；否则使用默认值 1
            if (!edit_output_image_number.value) {
                edit_output_image_number.value = 1
            }
            aspectRatioList.value = batch_generate_aspect_ratio_list
            // 有缓存的宽高比时优先使用缓存值
            if (!edit_aspect_ratio.value) {
                edit_aspect_ratio.value = '9:16'
            }
            // 仅在当前没有多选模型时设置默认值，避免覆盖已恢复的多选配置
            if (!edit_model_list.value || !edit_model_list.value.length) {
                // 再兜底一次，确保对比模式下始终有一个可用模型（且已过滤）
                syncStandardToCompare()
            }
            upload_image_limit.value = 10
        } else {
            // 退出模型对比：保留一个模型回填到标准模式
            syncCompareToStandard()
            // 关闭批量时也只在没有缓存值的情况下设置默认
            if (!edit_output_image_number.value) {
                edit_output_image_number.value = 1
            }
            if (!edit_aspect_ratio.value) {
                edit_aspect_ratio.value = aspectRatioList.value?.[0] || ''
            }
        }
    }
)
</script>
<style scoped lang="less">
.setting-side {
    width: 100%;
    height: 100%;
    background-color: #222222;
}
</style>
